<template>
  <v-app>
    <v-card color="#5aad70">
      <v-card-title class="headline" style="color: white"
        >Configuración general de la aplicación</v-card-title
      >
      <v-card-text style="background-color: white; color: black">
        <v-row>
          <v-col>
            <v-dialog
              ref="dialog"
              v-model="startTimeModal"
              :return-value.sync="configuration.dates_start_time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="configuration.dates_start_time"
                  label="Hora de inicio"
                  prepend-icon="mdi-access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="startTimeModal"
                v-model="configuration.dates_start_time"
                full-width
                :format="'24hr'"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startTimeModal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(configuration.dates_start_time)"
                  >Cerrar</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col>
            <v-dialog
              ref="dialog2"
              v-model="endTimeModal"
              :return-value.sync="configuration.dates_end_time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="configuration.dates_end_time"
                  label="Hora de término"
                  prepend-icon="mdi-access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="endTimeModal"
                v-model="configuration.dates_end_time"
                full-width
                :format="'24hr'"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="endTimeModal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog2.save(configuration.dates_end_time)"
                  >Cerrar</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions style="background-color: white">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="saveConfiguration">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      configuration: {
        dates_start_time: "",
        dates_end_time: "",
      },
      startTimeModal: false,
      endTimeModal: false,
    };
  },
  methods: {
    getData() {
      this.openLoader();
      window.setTimeout(() => {
        const peticion = this.sendRequest(
          this.$store.state.apiUrl + "configuration"
        );

        peticion
          .then(({ data }) => {
            this.configuration = data;
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
    saveConfiguration() {
      this.openLoader();
      window.setTimeout(() => {
        const peticion = this.sendRequest(
          this.$store.state.apiUrl + "configuration",
          this.configuration,
          "PUT"
        );
        peticion
          .then(({ message }) => {
            this.showSuccessMessage(message);
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
